import { Box, Center } from '@mantine/core';

import { AuthHeader } from '@/components/layout';
import { AcceptInviteForm } from '@/features/auth/components/AcceptInviteForm';

export const AcceptInvitePage = () => {
  return (
    <Box mih="100dvh" style={{ backgroundColor: 'var(--color-bg-canvas)' }}>
      <AuthHeader />
      <Center px={{ base: 16, md: 24 }} py={{ base: 32, md: 80 }}>
        <AcceptInviteForm />
      </Center>
    </Box>
  );
};
